import ApiClient from './ApiClient';

class SocialInboxConfigsAPI extends ApiClient {
  constructor() {
    super('social_inbox_configs', { accountScoped: true });
  }
}

export default new SocialInboxConfigsAPI();
